import Axios from 'axios';

export interface IPaginationResponse<TData = {}> {
  data: TData[];
  pagination: { page: number; limit: number; total: number; nextPage?: number };
}

export const getAxios = () => {
  const axios = Axios.create({
    baseURL: '/api',
  });

  axios.interceptors.request.use(async config => {
    config.headers = config.headers || {};

    const jwt = localStorage.getItem('auth_token');
    if (jwt) {
      config.headers['x-auth-token'] = jwt;
    }

    return config;
  });

  axios.interceptors.response.use(
    res => res,
    async err => {
      if (err.response?.status === 401) {
        if (!location.pathname.startsWith('/admin/login')) {
          location.href = '/admin/login';
        }
      }

      return Promise.reject(err);
    }
  );

  return axios;
};
